import { graphClient } from "@gygadmin/client3";
import {
  AvailabilityToPricingInput,
  ConnectAvailabilityToPricingMutation,
  ConnectAvailabilityToPricingMutationVariables,
  DisconnectAvailabilityToPricingMutation,
  DisconnectAvailabilityToPricingMutationVariables,
} from "@client/autogenerated/graphql/operations";
import {
  ConnectAvailability,
  DisconnectAvailability,
} from "@client/graphql/pricing-availability/pricing-availability";

class AvailabilityService {
  connectAvailabilityToPricing(
    input: AvailabilityToPricingInput,
  ): Promise<ConnectAvailabilityToPricingMutation["connectAvailabilityToPricing"]> {
    return graphClient
      .gql()
      .mutate<ConnectAvailabilityToPricingMutation, ConnectAvailabilityToPricingMutationVariables>({
        mutation: ConnectAvailability,
        variables: {
          input,
        },
      })
      .then((res) => res.data?.connectAvailabilityToPricing);
  }

  disconnectAvailabilityToPricing(
    input: AvailabilityToPricingInput,
  ): Promise<DisconnectAvailabilityToPricingMutation["disconnectAvailabilityToPricing"]> {
    return graphClient
      .gql()
      .mutate<
        DisconnectAvailabilityToPricingMutation,
        DisconnectAvailabilityToPricingMutationVariables
      >({
        mutation: DisconnectAvailability,
        variables: {
          input,
        },
      })
      .then((res) => res.data?.disconnectAvailabilityToPricing);
  }
}

export default new AvailabilityService();
